import React from 'react';
import DashboardLayout from 'layouts/Dashboard';
import { PanelsLayout } from './components/PanelsLayout';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';

/**
 * Componente DynamicPanel - Panel Dinámico del Dashboard.
 *
 * Este componente renderiza el panel dinámico que permite a los usuarios
 * configurar y visualizar diferentes widgets en un layout personalizable.
 *
 * @returns {React.ReactElement} El componente DynamicPanel envuelto en DashboardLayout.
 *
 * @requires DashboardLayout - Layout principal del dashboard.
 * @requires PanelsLayout - Componente que gestiona el layout de los paneles.
 * @requires useTranslation - Hook de i18next para internacionalización.
 *
 * @see {@link PanelsLayout} para la configuración de los paneles.
 *
 * @since 1.0.0
 * @author David Maldonado
 * (c) Servicios de Monitoreo S.A. - Santiago, Chile
 */

export function DynamicPanel() {
  const { t } = useTranslation();
  const clienteId = sessionStorage.getItem('client_id');
  const isAdmin = Boolean(sessionStorage.getItem('admin_id')) || false;
  return (
    <DashboardLayout
      title={t('dynamicPanel.title')}
      callbackFromParent={() => {}}
      isFirstTime={true}
    >
      {(clienteId === '1' || isAdmin) && (
        <Box padding={4}>
          <PanelsLayout />
        </Box>
      )}
      {(clienteId !== '1' && !isAdmin) && (
        <Box padding={4}>
          <Alert severity="info">{t('dynamicPanel.noAccess')}</Alert>
        </Box>
      )}
    </DashboardLayout>
  );
}
